import { ActionIcon, Flex, PinInput as MantinePinInput } from "@mantine/core";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { type CSSProperties, useState } from "react";

interface PinInputProps {
  value: string;
  onChange: (value: string) => void;
}

// Masked via CSS, not `mask` (type="password"), so password managers don't autofill the PIN.
// Custom `style` replaces Mantine's inline vars, so they are repeated here.
const boxStyle = {
  "--input-padding": "0",
  "--input-text-align": "center",
} as CSSProperties;
const maskedStyle = {
  ...boxStyle,
  WebkitTextSecurity: "disc",
} as CSSProperties;

const PinInput = ({ value, onChange }: PinInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPasswordVisible(!isPasswordVisible);
  };
  return (
    <Flex align="center" gap={4}>
      <MantinePinInput
        length={4}
        type="number"
        inputType="text"
        inputMode="numeric"
        oneTimeCode={false}
        size="md"
        value={value}
        onChange={onChange}
        getInputProps={() => ({
          style: isPasswordVisible ? boxStyle : maskedStyle,
        })}
        gap={4}
        ariaLabel="PIN"
      />
      <ActionIcon
        variant="subtle"
        color="gray"
        aria-label={isPasswordVisible ? "Hide PIN" : "Show PIN"}
        aria-pressed={isPasswordVisible}
        onClick={togglePasswordVisibility}>
        {isPasswordVisible ? <IconEyeOff size={18} /> : <IconEye size={18} />}
      </ActionIcon>
    </Flex>
  );
};
export default PinInput;
